import { useEffect, useState } from "react";
import FilterItem from "../../components/Filter/FilterItem";
import FilterItems from "../../components/Filter/FilterItems";
import DropdownInput from "../../components/Form/DropdownInput";
import TextInput from "../../components/Form/TextInput";
import { IzobrazevanjeListType } from "../../types/Izobrazevanje/IzobrazevanjeListType";
import { IzobrazevanjeStatus, IzobrazevanjeVrsta } from "../../utils/Enums";
import useFetchIzobrazevanjeTipAll from "../sifrant/izobrazevanjeTip/IzobrazevanjeTipHooks";
import IzobrazevanjeListTable from "./IzobrazevanjeListTable";
import IzobrazevanjeJavnoListTable from "./IzobrazevanjeJavnoListTable";

type IzobrazevanjeListTableFiltriArgs = {
    izobrazevanjeListData: IzobrazevanjeListType[],
    izobrazevanjeVrsta: IzobrazevanjeVrsta,
}

const IzobrazevanjeListTableFiltri = ({ izobrazevanjeListData, izobrazevanjeVrsta }: IzobrazevanjeListTableFiltriArgs) => {
    const { data: FilterIzobrazevanjeTipi } = useFetchIzobrazevanjeTipAll();
    const [listData, setListData] = useState({ allData: izobrazevanjeListData, filteredData: izobrazevanjeListData });
    const [filterNaziv, setFilterNaziv] = useState("");
    const [filterTip, setFilterTip] = useState(-1);
    const [filterStatus, setFilterStatus] = useState(-1);

    function filterDataIzobrazevanjeNaziv(e: React.ChangeEvent<HTMLInputElement>) {
        // if (e.target.value === "" || e.target.value.length < 3)
        //     setFilterNaziv(""); 
        // else if (e.target.value.length > 2)

        setFilterNaziv(e.target.value);
    }

    function filterDataIzobrazevanjeTip(e: React.ChangeEvent<HTMLSelectElement>) {
        setFilterTip(Number(e.target.value));
    }

    function filterDataIzobrazevanjeStatus(e: React.ChangeEvent<HTMLSelectElement>) {
        setFilterStatus(Number(e.target.value));
    }

    //TODO: useFilteredData - mogoče za pogledat?
  
    useEffect(() => {
        setListData({ allData: izobrazevanjeListData, filteredData: izobrazevanjeListData
            .filter(ld =>
                (ld.naziv.toLowerCase().includes(filterNaziv.toLowerCase()) || filterNaziv === "")
                && (ld.izobrazevanjeTipId === Number(filterTip) || filterTip === -1)
                && (ld.status === Number(filterStatus) || filterStatus === -1)
                )});
    }, [izobrazevanjeListData, izobrazevanjeVrsta, filterNaziv, filterTip, filterStatus])

    console.log("IzobrazevanjeListTableFiltri - izobrazevanjeListData", izobrazevanjeListData);

    return (
        <>
            <FilterItems>
                <FilterItem>
                    <TextInput
                        label="Poišči"
                        type="text"
                        width="calc(8vw + 9rem)"
                        placeholder="Naziv"
                        err={null}
                        errField="Naziv"
                        onChange={(e) => filterDataIzobrazevanjeNaziv(e)}
                    />
                </FilterItem>
                <FilterItem>
                    <DropdownInput 
                        label="Kategorija"
                        width="180px"
                        value={filterTip}
                        onChange={(e) => filterDataIzobrazevanjeTip(e)}
                    >
                        <option key={-1} value={-1}>vse kategorije</option>
                        {FilterIzobrazevanjeTipi && FilterIzobrazevanjeTipi.map((it) => (
                            <option key={it.izobrazevanjeTipId} value={it.izobrazevanjeTipId}>{it.naziv}</option>
                        ))}
                    </DropdownInput>
                </FilterItem>
                <FilterItem>
                    <DropdownInput
                        label="Status"
                        width="180px"
                        value={filterStatus}
                        onChange={(e) => filterDataIzobrazevanjeStatus(e)}
                    >
                        <option key={-1} value={-1}>vsi statusi</option>
                        <option key={IzobrazevanjeStatus.VPripravi} value={IzobrazevanjeStatus.VPripravi}>v pripravi</option>
                        <option key={IzobrazevanjeStatus.Objavljeno} value={IzobrazevanjeStatus.Objavljeno}>objavljeno</option>
                    </DropdownInput>
                </FilterItem>
            </FilterItems>
            
            {izobrazevanjeVrsta === IzobrazevanjeVrsta.Javno ?
                <IzobrazevanjeJavnoListTable izobrazevanjeData={listData.filteredData} />
                : <IzobrazevanjeListTable izobrazevanjeData={listData.filteredData} />
            }
        </>
    );
}

export default IzobrazevanjeListTableFiltri;